"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.miniCartRemoveCreator = void 0;
var util_1 = require("./util");
var miniCartRemoveCreator = function (event) {
    return (0, util_1.removeFromCartEvent)(event, 'mini-cart-remove');
};
exports.miniCartRemoveCreator = miniCartRemoveCreator;
